import { memo } from "react";
import { clsx } from "clsx";

import { Icon } from "@/shared/ui/Icon";
import { Portal } from "@/shared/ui/Portal";

import spinnerIcon from "@/shared/assets/icons/spinner.svg";

import cls from "./Spinner.module.scss";

export enum SpinnerView {
  Centered = "Centered",
}

interface SpinnerProps {
  className?: string;
  view?: SpinnerView;
}

export const Spinner = memo((props: SpinnerProps) => {
  const { className, view } = props;

  const icon = <Icon Svg={spinnerIcon} className={clsx(cls.Spinner, { [cls[view]]: true }, [className])} />;

  if (view === SpinnerView.Centered) {
    return <Portal>{icon}</Portal>;
  }

  return icon;
});
